import { call, put, select, takeEvery } from 'redux-saga/effects';
import { INewDealerRequestCart, NewDealerActionKeys, UpdateNewDealerCart } from '..';
import { IState } from '../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { cartsActionCreators } from '../../carts';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { newDealerActionCreators } from '../newDealerActionCreators';
import * as api from '../newDealerApi';
import { getNewDealerCart } from '../newDealerSelectors';

function* updateNewDealerCart(action: UpdateNewDealerCart) {
  yield put(uiActionCreators.showSpinnerDialog());

  // get current cart
  const cart: INewDealerRequestCart = yield select((state: IState) =>
    getNewDealerCart(state, action.payload.newDealerRequestId, action.payload.brand)
  );

  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestCart>> = yield call(
    api.updateNewDealerProgram,
    {
      ...cart,
      ...action.payload
    }
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(newDealerActionCreators.setProgram(response.value.value));

      if (response.value.value.cartLines && response.value.value.cartLines.length > 0) {
        yield put(cartsActionCreators.updateCartLines(response.value.value.cartLines));
      }
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateNewDealerCart() {
  yield takeEvery(NewDealerActionKeys.UPDATE_NEW_DEALER_CART, updateNewDealerCart);
}
